import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=b2edcb6c"
import script from "./Recap.vue?vue&type=script&lang=js"
export * from "./Recap.vue?vue&type=script&lang=js"
import style0 from "./Recap.vue?vue&type=style&index=0&id=b2edcb6c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports